var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createMuiTableCellOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, typography = _a.typography, shape = _a.shape;
    return ({
        root: {
            padding: spacing(4),
            borderBottom: undefined,
            color: palette.text.secondary,
        },
        head: __assign({ 
            // Decimal value to match spacing without adding line-height inconsistency
            paddingTop: spacing(4.5), paddingBottom: spacing(4.5), color: undefined }, typography.caption),
        stickyHeader: {
            backgroundColor: palette.background.paper,
        },
        body: {
            color: undefined,
            borderBottom: "1px solid ".concat(palette.divider),
            // Round top corners on the first body row
            "[class*='MuiTableRow-root']:first-child &": {
                "&:first-child": { borderTopLeftRadius: shape.borderRadius },
                "&:last-child": { borderTopRightRadius: shape.borderRadius },
            },
            // Round bottom corners on the last body row
            "[class*='MuiTableRow-root']:last-child &": {
                borderBottom: "none",
                "&:first-child": { borderBottomLeftRadius: shape.borderRadius },
                "&:last-child": { borderBottomRightRadius: shape.borderRadius },
            },
        },
        paddingCheckbox: {
            width: spacing(12),
            padding: spacing(0, 2),
            "&:first-child": {
                paddingRight: 0,
                width: spacing(10),
            },
            "&:last-child": {
                paddingRight: undefined,
                paddingLeft: undefined,
            },
            // Cells right against checkboxes have special padding
            "& + :not($paddingCheckbox):not($paddingNone)": {
                paddingLeft: spacing(2),
            },
        },
        sizeSmall: {
            padding: undefined,
            paddingTop: spacing(2),
            paddingBottom: spacing(2),
            "&:last-child": {
                paddingRight: undefined,
            },
            "&$head": {
                paddingTop: spacing(2.5),
                paddingBottom: spacing(2.5),
            },
            "&$paddingCheckbox": {
                width: undefined,
                padding: undefined,
                "&:last-child": {
                    paddingLeft: spacing(4),
                    paddingRight: spacing(2),
                },
                "& > *": { padding: undefined },
            },
        },
    });
};
//# sourceMappingURL=MuiTableCell.js.map